<app-navbar-style-two></app-navbar-style-two>

<!-- <app-posnavbar></app-posnavbar> -->
<!-- <div class="banner-area-two client-slider owl-carousel owl-theme">
    <div class="client-item">
        <img src="https://medeilpos.blob.core.windows.net/websiteimage/salon&spa software - medeilcloud pos.png" alt="salon & spa software - medeilcloud pos">
        <div class="overlay-buttons row">
            <div class="col-lg-6">
                <button type="button" class="default-btn1">14 Days Free Trial</button>
            </div>
            <div class="col-lg-6">
                <button type="button" class="default-btn1" (click)="appointment('Beauty and cosmetics vertical')">Demo Request</button>
            </div>
        </div>
    </div>
</div> -->
<div class="slider-area owl-carousel owl-theme">
  <div class="slider-item item-bg-bandc">
      <div class="d-table">
          <div class="d-table-cell">
              <div class="container">
                  <div class="slider-content">
                      <h1 i18n>MEDEIL Beauty Software – Smart Management for Salons & Spas</h1>
                      <!-- <h2 i18n>Manage Inventory, Sales, and Customer Loyalty Seamlessly</h2> -->
                          <button i18n type="button" class="default-btn" (click)="appointment('Beauty and cosmetics vertical')">Get Started Now</button>
                  </div>
              </div>
          </div>
      </div>
  </div>
</div>


<br>
<div class="container-md p-5 box-container">
    <p i18n style="color:white">Unlock the full potential of your beauty business with MEDEIL Beauty Software. Designed for modern salons and spas, our platform streamlines every aspect of your operations, so you can focus on delivering exceptional client experiences and growing your brand.</p>
</div>
<br>




<ngx-smart-modal #enquirypos identifier="enquirypos" [closable]="false">
  <div class="custom-modal">
     <button class="close-btn" (click)="closeModal()">X</button>
     <div class="modal-header">
         <h5 i18n class="modal-title" id="exampleModalLabel">Enquiry Form</h5>
     </div>
       <div class="modal-body">
         <form [formGroup]="enquiryForm">
           <div class="form-group">
             <label i18n for="recipient-name" class="col-form-label"><strong>Name</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="leadname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Organisation</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="organizationname" required>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Email</strong><span class="star">*</span></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="primaryemail" required>
             <div *ngIf="enquiryForm.controls.primaryemail.invalid && (enquiryForm.controls.primaryemail.dirty || enquiryForm.controls.primaryemail.touched)">
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.required" style="color: red;">Email is required.</div>
              <div i18n *ngIf="enquiryForm.controls.primaryemail.errors?.pattern" style="color: red;">Invalid email format.</div>
            </div>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Country</strong></label>
             <!-- <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="countryname1"> -->
             <select class="form-control"  formControlName="countryname1" style="font-size: 12px;" (change)="countrychange()">
              <!-- (change)="countrychange()" -->
              <option i18n select disabled value="0" >---Select Country---</option>
              <option  value="{{ country[1] }}" *ngFor="let country of totalcountry">{{country[1]}}</option>

            </select>
           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Mobile</strong><span class="star">*</span></label>
             <div class="row">
               <div class="col-lg-3">
                 <input type="text" name="rec" readonly class="form-control mobile-field" [(ngModel)]="dialcode" id="recipient-name" formControlName="phonedialcode">
               </div>
               <div class="col-lg-9">
                 <input type="text" name="rec" class="form-control mobile-field" maxlength="15" id="recipient-name" formControlName="primaryphone"
                 autocomplete="off" oninput="this.value = this.value.replace(/[^0-9.]/g, '').replace(/(\..*)\./g, '$1')">
               </div>
             </div>

           </div>
           <div class="form-group">
             <label i18n for="message-text" class="col-form-label"><strong>Description</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name" formControlName="address1">
           </div>
           <!-- <div class="form-group">
             <label for="message-text" class="col-form-label"><strong>Enter captcha</strong></label>
             <input type="text" name="rec" class="form-control" id="recipient-name">
           </div> -->
           <label i18n for="message-text" class="col-form-label captchalabel"><strong>Enter captcha</strong></label>
           <div class="input-group">
              <input type="text" class="form-control ecaptcha" required formControlName="enteredcaptcha" required="required"
               (change)="checkCaptcha()"/>
              <input type="text" class="form-control gcaptcha" formControlName="generatedcaptcha" readonly
              [(ngModel)]="captcha"/>
              <i class="fa fa-arrows-rotate refresh" (click)="generatecaptcha()"></i>
            </div>
            <div *ngIf="ecaptcha">
              <p style="color: red">{{ errorcaptcha }}</p>
            </div>
           <div class="form-group">

                 <label i18n class="container1 mt-3">I Accept Terms & Conditions & MEDEIL Privacy Policy – Your Data Security & Rights
                     <input type="checkbox" checked="checked" formControlName="checkbox">
                     <span class="checkmark"></span>
                 </label>
           </div>
           <div class="btn-group mt-3" *ngIf="!showElement">
             <button i18n type="button" class="enquiry-btn" (click)="submitenquery()" >Submit</button>

           </div>


         </form>
       </div>
 </div>
</ngx-smart-modal>
<ngx-smart-modal #appointmentform identifier="appointmentform" [closable]="false">


  <div class="custom-modal"  >
     <button class="close-btn" (click)="closeModal()">X</button>
      <div class="modal-header-appointment">
          <h4 i18n class="modal-title" id="exampleModalLabel">Demo Request</h4>
      </div>
        <div class="modal-body">

           <div class="row">
              <div class="col-lg-12">
                 <mat-form-field >

                    <input matInput [matDatepicker]="picker" placeholder="Choose a date" (dateChange)="slectdate($event)" >
                    <mat-datepicker-toggle matSuffix [for]="picker"></mat-datepicker-toggle>
                    <mat-datepicker #picker></mat-datepicker>
                 </mat-form-field>

              </div>
              <div  align="center" *ngIf="showElement">
                 <img height="200px" width="200px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
               </div>
              <div class="col-lg-12" *ngIf="appointment_time">

                  <div class="button-container">
                    <button class="flex-button" *ngFor="let time of timeSlots" (click)="selectTime(time)" [ngClass]="{ 'clicked': selectedTime === time }">{{ time }}</button>
                </div>
                <div  align="center" *ngIf="showElementsave">
                  <img height="100px" width="100px" src="https://medeilpos.blob.core.windows.net/posimage/loading.gif" alt="gif" loading="lazy">
                </div>
                  <div class="shedule-submit">
                    <button i18n class="shedulebtn" (click)="savelead()">Submit</button>
                  </div>
              </div>
           </div>

        </div>
  </div>
</ngx-smart-modal>
<div class="newslider" >

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/anu-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/apollo-hospitals.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bellamed-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/bk-heart-hospital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/booncholai-super-market.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/emedsure.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/express-pharmacy.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/falcon-healthcare.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/global-bridge-pharmaceutical.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/hawi-family-hostpital.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/henry-jackson-foundation.webp" alt="image" height="200" width="300" priority>
  </div>

  <div class="place-list-item">
      <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/imcri.webp" alt="image" height="200" width="300" priority>
  </div>

</div>
<!-- <div class="section-title container gradient-text mb-2" >

    <h2>Features</h2>
</div> -->
<!-- ---------------------------- -->
<section class="info-section">
    <div class="container2">
        <div class="text-content">
            <h2 i18n class="title">Effortless Appointment Scheduling and Client Management</h2>
            <p i18n class="description">
             Say goodbye to double bookings and missed appointments. MEDEIL Beauty Software offers a powerful, easy-to-use appointment calendar that lets you manage bookings, staff schedules, and client preferences in one place. Automated reminders reduce no-shows, while detailed client profiles help you personalize every visit and build lasting relationships.
            </p>
        </div>
    </div>
</section>

<div id="services" class="services section">
    <div class="container">
      <div class="row">
        <div class="col-lg-8 offset-lg-2">
          <div class="section-heading  wow fadeInDown" data-wow-duration="1s" data-wow-delay="0.5s">
            <div i18n class="gradient-text"><h2>Beauty & Cosmetic Store Software | Simplify Your Retail Operations</h2>for you</div>
            <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
           <p i18n>Running a beauty and cosmetic store is more than just selling products – it’s about creating an experience. From managing fast-moving inventory and promotions to building customer loyalty, the challenges can be overwhelming. That’s where Medeil’s Beauty & Cosmetic Store Software comes in – a smart, all-in-one solution designed to streamline your operations and help your business shine.</p>
          </div>
        </div>
      </div>
    </div>
    <div class="container">
      <div class="row">
        <div class="col-lg-3">
          <div class="service-item first-service">
            <div class="icon"></div>
            <h4 i18n>Save Time and Reduce Errors</h4>
            <p i18n style="line-height: 1.6;">Automate repetitive tasks like inventory tracking and billing, so you can focus on your customers.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item second-service">
            <div class="icon"></div>
            <h4 i18n>Improve Customer Experience</h4>
            <p i18n style="line-height: 1.3;">Provide faster, more personalized service with features like CRM and purchase history tracking.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item third-service">
            <div class="icon"></div>
            <h4 i18n>Optimize Inventory</h4>
           <p i18n style="line-height: 1.9;">Avoid overstocking or running out of popular items with real-time inventory tracking and alerts.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
        <div class="col-lg-3">
          <div class="service-item fourth-service">
            <div class="icon"></div>
            <h4 i18n>Boost Sales</h4>
         <p i18n style="line-height: 1.3;">Use sales insights to identify trends, plan promotions, and increase revenue.</p>
            <div class="text-button">
              <a i18n>Read More <i class="fa fa-arrow-right"></i></a>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
<!-- ---------------------------- -->



<br>
<section class="benefits-section box-container">
    <div class="benefits-container">
        <div class="benefits-grid">
            <div class="benefit-card1">
                <h4 i18n>Inventory and Billing Made Simple</h4>
                <p i18n>Never run out of your best-selling products again. MEDEIL Beauty Software provides real-time inventory tracking, low-stock alerts, and automated reordering. Integrated billing ensures fast, accurate invoicing and seamless payment processing, so you can spend less time on paperwork and more time with your clients.</p>
            </div>
            <div class="benefit-card1">
                <h4 i18n>How to Get Started with MEDEIL Beauty Software</h4>
                <p i18n>Getting started is easy! Our onboarding process is designed to get your salon or spa up and running in no time. Enjoy step-by-step setup guidance, personalized training, and ongoing support from our dedicated team. Whether you’re switching from another system or starting fresh, MEDEIL makes the transition smooth and stress-free.</p>
            </div>
        </div>
    </div>
</section>
<br>



<!-- start of key  -->
<section class="about section-padding" id="features">
    <div class="section-title gradient-text ">
        <h2 i18n style="text-align: center;">Key Features for Beauty Business Success</h2>
    </div>
    <div class="container">
        <div class="row">
            <div class="col-lg-10 col-12 ms-lg-auto mb-2 mb-lg-0">
                <nav>
                    <div class="nav nav-tabs" id="nav-tab" role="tablist">
                        <button i18n class="nav-link active" id="nav-intro-tab" data-bs-toggle="tab" data-bs-target="#nav-intro" type="button" role="tab" aria-controls="nav-intro" aria-selected="true">Real-Time Appointment Scheduling</button>

                        <button i18n class="nav-link" id="nav-profile-tab" data-bs-toggle="tab" data-bs-target="#nav-profile" type="button" role="tab" aria-controls="nav-profile" aria-selected="false">Comprehensive Client Management</button>

                        <button i18n class="nav-link" id="nav-faq-tab" data-bs-toggle="tab" data-bs-target="#nav-faq" type="button" role="tab" aria-controls="nav-faq" aria-selected="false">Salon POS Integration</button>
                        <button i18n class="nav-link" id="nav-faq-data" data-bs-toggle="tab" data-bs-target="#nav-data" type="button" role="tab" aria-controls="nav-data" aria-selected="false">Staff Performance Tracking</button>
                    </div>
                </nav>
            </div>
            <div class="col-12">
                <div class="tab-content" id="nav-tabContent">
                    <div class="tab-pane fade show active" id="nav-intro" role="tabpanel" aria-labelledby="nav-intro-tab">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/opticalchainstoresoftware - medeilcloud hq.png" class="img-fluid" alt="optical chain store software - medeilcloud hq" height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Real-Time Appointment Scheduling</h3>
                                  <p i18n>Book, reschedule, and cancel appointments with just a few clicks.</p>
                                    <p i18n>Administrators should be able to monitor and manage all pharmacy locations' activities from a single dashboard thanks to the software's centralized management features.</p>
                                    <!-- <p i18n>Managing user access, pricing, promotions, and inventory are all included in this.</p> -->
                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade" id="nav-profile" role="tabpanel" aria-labelledby="nav-profile-tab">
                        <div class="row">
                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Comprehensive Client Management</h3>
                              <!-- <p i18n>In order to allow each pharmacy to function independently and to enable centralized management and communication between stores, the software should handle several pharmacy locations. </p> -->
                              <p i18n>Store client histories, preferences, and notes for tailored service.</p>
                            </div>

                            <div class="col-lg-6 col-12 mt-lg-0 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloud hq.png" class="img-fluid" alt="medical device software for chainstores medeilcloud hq"  height="400" width="500" priority>
                            </div>
                        </div>
                    </div>

                    <div class="tab-pane fade mb-4" id="nav-faq" role="tabpanel" aria-labelledby="nav-faq-tab">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/multi store software = medeilcloud hq.png" class="img-fluid" alt="multi store software medeilcloud hq"  height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Salon POS Integration</h3>

                              <!-- <p i18n>The software must give top priority to safeguarding patient information and adhering to HIPAA (Health Insurance Portability and Accountability Act) and other healthcare standards, such as WHO-DDD, WHO-ATC Coding, and WHO-ICD Standards.</p> -->
                              <p i18n>Process payments quickly and securely, track sales, and manage discounts or loyalty programs.</p>


                            </div>
                        </div>
                    </div>
                    <div class="tab-pane fade mb-4" id="nav-data" role="tabpanel" aria-labelledby="nav-faq-data">
                        <div class="row">
                            <div class="col-lg-6 col-12 mb-lg-0 mb-4 mt-4">
                                <img ngSrc="https://medeilpos.blob.core.windows.net/websiteimage/chainsoftware-medeilcloud hq.png" class="img-fluid" alt="chain software-medeilcloud hq"  height="400" width="500" priority>
                            </div>

                            <div class="col-lg-5 col-12 m-auto">
                                <h3 i18n class="mb-3">Staff Performance Tracking</h3>

                             <p i18n>
                               Monitor productivity, commissions, and service quality with insightful reports.</p>
                                <!-- <p i18n>This features support for upcoming expansions, modifiable processes, and adjustable settings.</p> -->
                            </div>
                         </div>
                    </div>
                </div>
            </div>

        </div>
    </div>
    <div id="faq"></div>
</section>
<!-- end of key feature -->






<!-- about  -->
<div id="about" class="about-us section">
  <div class="container">
    <div class="row">
      <div class="col-lg-6 align-self-center">
        <div class="section-heading">
          <h4 i18n>About what we do</h4>
          <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
          <!-- <img src="assets/images/heading-line-dec.png" alt=""> -->
        <p i18n>
        At Vanuston, we specialize in developing innovative beauty and cosmetics store software solutions tailored to meet the unique needs of retailers, salons, spas, and beauty brands.
        </p>
        </div>
        <div class="row">
            <div class="col-lg-6">
                <div class="box-item" routerLink="/medeil">
                  <h5 i18n><a >Standalone Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/medeilcloudpos">
                  <h5 i18n><a >SaaS Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/medeilcloudhq">
                  <h5 i18n><a >Chain Store Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-6">
                <div class="box-item" routerLink="/allotmed">
                  <h5 i18n><a >Distribution Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
              <div class="col-lg-12 text-center">
                <div class="box-item" routerLink="/hosbay-healthcare">
                  <h5 i18n><a >Hospital Inventory  Version</a></h5>
                  <!-- <p class="ptag">Lorem Ipsum Text</p> -->
                </div>
              </div>
          <div class="col-lg-12">
           <p i18n>
            As a leading player in the beauty and cosmetics store software space, Vanuston is committed to driving innovation and shaping the future of beauty retailing and the cosmetics industry.
           </p>
            <div>
              <!-- <button class="gradient-button"> Start Free Trial</button> -->
             </div>
            <!-- <span>*No Credit Card Required</span> -->
          </div>
        </div>
      </div>
      <div class="col-lg-6">
        <div class="right-image">
          <img src="https://medeilpos.blob.core.windows.net/websiteimage/medeilcloudpos.gif" alt="medical pos billing- medeilcloud pos" loading="lazy" >
        </div>
      </div>
    </div>
  </div>
</div>


<section class="beauty-benefits-section">
  <div class="beauty-container">
      <h3 i18n class="beauty-title">Who Can Benefit from Medeil’s Beauty & Cosmetic Store Software?</h3>
      <p i18n class="beauty-description">
          Our software is designed to streamline operations, ensuring efficiency and seamless management for beauty and cosmetic businesses.
      </p>

      <div class="beauty-cards">
          <div class="beauty-card">
              <div class="beauty-icon"><i class="fas fa-store"></i></div>
              <h3 i18n>Independent Beauty Stores</h3>
              <p i18n>Upgrade your beauty and cosmetic store with modern solutions for seamless management.</p>
          </div>

          <div class="beauty-card">
              <div class="beauty-icon"><i class="fas fa-shopping-bag"></i></div>
              <h3 i18n>Chain Cosmetic Stores</h3>
              <p i18n>Manage multiple store locations with our centralized system and automated inventory.</p>
          </div>

          <div class="beauty-card">
              <div class="beauty-icon"><i class="fas fa-leaf"></i></div>
              <h3 i18n>Specialty Beauty Stores</h3>
              <p i18n>Perfect for stores specializing in skincare, makeup, or organic beauty products.</p>
          </div>
      </div>
  </div>
</section>
<!-- ---- -->
  <div class="container mt-4">
      <div class="section-title gradient-text mt-2 mb-2" >

          <h2 i18n>Frequently Asked Questions</h2>
      </div>
      <div class="row pt-4">
          <div class="col-lg-6 col-md-12">
              <div class="faq-item">
                  <h4 i18n>Q: What features is your business software for beauty and cosmetics offering?</h4>
                  <p i18n><strong>A:</strong> Specific features like inventory control, POS capability, appointment scheduling, loyalty programs, customer relationship management (CRM), and interaction with e-commerce platforms are among the aspects that customers frequently inquire about.</p>
              </div>
          </div>

          <div class="col-lg-6 col-md-12">
              <div class="faq-item">
                  <h4 i18n>Q: Is your beauty and cosmetic business software customizable to fit our specific needs?</h4>
                  <p i18n><strong>A:</strong> Businesses may have unique requirements and workflows, so they want to know if the software can be tailored to their individual needs. This may include customizing fields, reports, workflows, and integrations.</p>
              </div>
          </div>

          <div class="col-lg-6 col-md-12">
              <div class="faq-item">
                  <h4 i18n>Q: What is the implementation process like, and how long does it take to get up and running?</h4>
                  <p i18n><strong>A:</strong> Implementing new software can be a significant undertaking for businesses, so they want to know about the implementation process, timeline, training options, and ongoing support available. They may also inquire about data migration, staff training, and technical support during and after the implementation process.</p>
              </div>
          </div>

          <div class="col-lg-6 col-md-12">
              <div class="faq-item">
                  <h4 i18n>Q: Is it possible for your beauty and cosmetics company software to work with our current tools and systems? </h4>
                  <p i18n><strong>A:</strong> Companies might already be using other software programs like CRM systems, e-commerce platforms, or accountancy software. In order to minimize redundant data entry and improve operations, they would like to know if the business software for the beauty and cosmetics industry can be easily integrated with their current systems.</p>
              </div>
          </div>
      </div>


  </div>
<div class="row mb-3 mt-3" style="width: 100%;">
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Crowd Review</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.3/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Google</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.8/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Capterra</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.4/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Software Suggest</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.7/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>G2 Crowd</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.1/5.0</p>
        </div>
  </div>
  <div class="col-lg-2">
      <div class="rating-section">
          <h6>Trust Radius</h6>
          <div class="rating-stars">
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9733;</div>
            <div class="starrate">&#9734;</div>
          </div>
          <p>4.6/5.0</p>
        </div>
  </div>
</div>

<br>
<div class="container-md p-5 box-container">
  <h3 i18n style="color: white;">Call to Action</h3>
  <p i18n style="color: white;">Ready to elevate your salon or spa? Request a free demo of MEDEIL Beauty Software and discover how our solution can simplify your business and delight your clients.</p>
  <a i18n (click)="appointment('Cosmetic-Beauty Demo')" class="cta-button">🚀 Request a Free Demo</a>
  </div>
<br>
<app-footer-style-two></app-footer-style-two>
